

























































































































































import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { LotInfo } from '~/models'
import MaterialIcon from '@/components/shared/MaterialIcon.vue'
import LotImage from '@/components/consumer_map_v3/LotImage.vue'
import projectConfig from '~/assets/project-config.json'
import { isHomesite } from '@/utils/lots'
import LotUtilsMixin from '~/mixins/LotUtilsMixin'
import globalStyling from '~/mixins/globalStyling'

@Component({
  components: {
    MaterialIcon,
    LotImage,
  },
  mixins: [LotUtilsMixin, globalStyling],
})
export default class Card extends mixins(LotUtilsMixin, globalStyling) {
  @Prop({ default: (): LotInfo => null })
  lotInfo: LotInfo

  @Prop({ default: '' }) lotType: string
  @Prop({ default: false }) customListing: boolean

  get tag(): string {
    if (typeof this.lotInfo.builder === 'string') return 'unassigned'
    else if (this.lotInfo.status === 'coming soon') return 'coming soon'
    else if (this.lotType === 'home site') {
      if (this.lotInfo.status === 'custom') return 'custom lot'
      else if (this.lotInfo.high_profile) return 'high profile'
    } else if (this.lotType === 'home') {
      if (this.lotInfo.status === 'model') return 'model home'
      else if (this.lotInfo.sale_id) return 'sold'
    }
  }

  get customPriceLabel(): string {
    if (isHomesite(this.lotInfo))
      return (
        projectConfig[this.$route.params.slug]?.homesitePriceLabel ||
        'Starting Price'
      )

    return (
      projectConfig[this.$route.params.slug]?.homePriceLabel || 'Listing Price'
    )
  }

  lotPrice(lotInfo: any, lotType: string) {
    const price = this.price(lotInfo, lotType)
    const callForDetailsLabel =
      projectConfig[this.$route.params.slug]?.callForDetailsLabel || ''
    if (price === 'Call for Details') {
      return callForDetailsLabel || price
    }
    return price
  }
}
